<div class="auth-wrapper">
    <div class="container pt-3 fade-in-left">
        <div class="d-flex align-items-center justify-content-center mb-4">
            <div class="p-2"><a [routerLink]="['/sign-in']"><i class="bi bi-chevron-left align-middle"></i></a></div>
            <div class="p-2 flex-grow-1 pl-2"><h1 class="text-center ">Recuperar Contraseña</h1></div>
        </div>

        <!-- Sections -->
        <div class="row-cols-12 m-4 mt-5">
            <div class="row p-3">    
                <div class="description mb-2">Ingresá tu e-mail para enviarte los pasos a seguir</div>
                <form [formGroup]="recuperarUsuario" (ngSubmit)="recuperar()">
                    <div class="mb-3 mt-3 text-start form-floating">
                        <input type="email" autocomplete="email" class="form-control" id="email" aria-describedby="emailHelp" formControlName="email" placeholder="ejemplo@email.com">
                        <label for="email" class="form-label">Email</label>
                        @if (recuperarUsuario.controls.email.touched && recuperarUsuario.controls.email.invalid) {
                            @if (recuperarUsuario.controls.email.errors?.['required']) {
                                <div class="alert-danger" role="alert">
                                    <small class="alert">Email es requerido</small>
                                </div>
                            }
                            @if (recuperarUsuario.controls.email.errors?.['email']) {
                                <div class="alert-danger" role="alert">
                                    <small class="alert">Email inválido</small>
                                </div>
                            }
                        }
                    </div>
                    @if (error()) {
                        <div class="alert alert-danger" role="alert">
                            <small>{{ error() }}</small>
                        </div>
                    }
                    <div class="d-grid mt-4 mb-2">
                        <button type="submit" [disabled]="loading() || recuperarUsuario.disabled" class="btn btn-primary btn-lg mt-5">{{ loading() ? 'Enviando...' : 'Recuperar contraseña' }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>